export default {
	namespaced: true,
	state: {
		id: undefined,
		name: undefined,
		description: undefined,
		template_id: undefined,
		mobile_pass_description: undefined,
		short_description: undefined,
		highlights: undefined,
		max_product_redemptions: undefined,
		active_dates: [],
		redemption_policy: {},
		check_in_validation: undefined,
		use_points: undefined,
		retail_price: undefined,
		convenience_fee: undefined,
		convenience_fee_type: undefined,
		tax_rate: undefined,
		paid_on_override: undefined,
		refund_policy: undefined,
		merchants: [],
		kickoff_date: undefined,
		launch_date: undefined,
		end_date: undefined,
		onboard_settings: {
			productReqs: []
		},
		media: []
	},
	getters: {
		getCurrentPass(state) {
			return state; // return all the properties as they are the current pass
		},
	},
	actions: {
		setCurrentPass({ commit }, pass) {
			commit('setCurrentPass', pass);
		},
	},
	mutations: {
		setCurrentPass(state, pass) {
			Object.assign(state, pass);
		}
	}
};
